<script>
  import { onMount } from "svelte"
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import DocDropdown from "../../../../../Shared/dropDown2.svelte"
  import TemplatesList from "../../../../../Stores/templatesList"
  import notify from "../../../../../Script/notify"
  import InstructModal from "./Components/instructModal.svelte"
  import { flatenObject } from "../../../../../Script/flatenObject"
  import { loadJs } from "../../../../../Script/loadLibrary"
  import { capitalizeArrayEntries, fetchSelectedDocumentTemp, getDocumentsList } from "../../Script/bulkUpload"
  import { fetchFileTemplate, createNewBulkSession } from "../../Script/bulkUpload"

  /**
   * @type {boolean} whethe to disable next btn or not
   */
  let disableNextBtn = false
  /**
   * @typedef {Object} notificationName
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationName}
   */
  let notificationName = {
    close() {},
  }
  /**
   * @typedef {Object} notificationDocument
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationDocument}
   */
  let notificationDocument = {
    close() {},
  }
  /**
   * @typedef {Object} notificationMaxChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationMaxChar}
   */
  let notificationMaxChar = {
    close() {},
  }
  /**
   * @typedef {Object} notificationMinChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationMinChar}
   */
  let notificationMinChar = {
    close() {},
  }
  /**
   * @typedef {Object} notificationSplChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationSplChar}
   */
  let notificationSplChar = {
    close() {},
  }
  /**
   * @type {Number} indicates the maximum characters
   */
  let maxCharacters = 50
  /**
   * @type {Number} indicates the minimum characters
   */
  let minCharacters = 3
  /**
   * @type {RegExp} Regular expression to match allowed characters
   */
  let allowedCharsRegex = /^[A-Za-z0-9\s-()+&.]+$/
  // let allowedCharsRegex = /^[A-Za-z0-9\s-_]+$/
  /**
   * @type {RegExp} Regular expression to match allowed characters for autofillRows
   */
  const positiveNumberRegex = /^[0-9]*[1-9][0-9]*$/
  /**
   * @type {boolean} whether to show instruct modal or not
   */
  let showInstructModal = false

  let timer

  let parsedJson = {}
  /**
   * @type {Boolean} whether the email linked with the selected document template or not
   */
  let isEmailLinked = false
  /**
   * @type {Boolean} whether the file linked with the selected document template or not
   */
  let isFileLinked = false
  /**
   * @typedef {Object} notificationNoFileEmail
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationNoFileEmail}
   */
  let notificationNoFileEmail = {
    close() {},
  }
  /**
   * @typedef {Object} notificationRowCount
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationRowCount}
   */
  let notificationRowCount = {
    close() {},
  }
  /**
   * @typedef {Object} notificationExpired
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationExpired}
   */
  let notificationExpired = {
    close() {},
  }
  /**
   * @typedef {Object} notificationEmptyExpired
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationEmptyExpired}
   */
  let notificationEmptyExpired = {
    close() {},
  }
  /**
   * @typedef {Object} notificationTitle
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationTitle}
   */
  let notificationTitle = {
    close() {},
  }
  /**
   * @typedef {Object} notificationNoEmail
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationNoEmail}
   */
  let notificationNoEmail = {
    close() {},
  }
  /**
   * @typedef {Object} notificationNoFile
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationNoFile}
   */
  let notificationNoFile = {
    close() {},
  }

  /**
   * @typedef {Object} session - represents the individual session values
   * @type {Object}
   * represents the individual session values
   *
   * @property {String} name - name of the current session
   * @property {Number} document - represents the selected document ID
   * @property {String} documentName - represents the selected document template name
   * @property {Boolean} toGenerateFiles - whether generate the files from the data or upload new files
   * @property {Boolean} toSendEmail - to send email or not after publishing
   * @property {Number} autoFillRows - rows to be autofilled in excelsheet
   * @property {String} title - title of the document
   * @property {Date} expiry - represents the expiry date of the document
   */
  let session = {
    document: undefined,
    documentName: "None",
    toGenerateFiles: false,
    toSendEmail: false,
  }
  /**
   * @type {String} file template id
   */
  let fileTempID
  /**
   * @type {number} pageNumber
   */
  let page = 1
  /**
   * @type {number} total document count
   */
  let count
  /**
   * @type {number} total pages
   */
  let maxPage
  /**
   * @type {number} starting count of the docList
   */
  let startCount = 1
  /**
   * @type {number} ending count of the docList
   */
  let endCount = 10
  /**
   * @type {boolean} whether to show loading screen or not
   */
  let showLoading = false
  /**
   * @type {boolean} File name for downloaded xl file (part-1) - not editable
   */
  let fileName = ""
  /**
   * @type {boolean} File name for downloaded xl file (part-2)
   */
  let fileName2 = ""

  let isTemplateFetching = false

  onMount(async () => {
    try {
      // Disable the 'Next' button initially
      disableNextBtn = true

      // Retrieve the list of documents
      let documentList = await getDocumentsList(page)

      count = documentList.count

      maxPage = Math.ceil(count / 10)

      endCount = count < 10 ? count : 10

      // show document templates by filtering only when they have name
      $TemplatesList.document = documentList.templates.filter((a) => a.name)
      // Update $TemplatesList with the document templates, sorted by creation date
      // $TemplatesList.document = $TemplatesList.document.sort((a, b) => new Date(b.created) - new Date(a.created))
      $TemplatesList.document = $TemplatesList.document.sort((a, b) => new Date(b.modified) - new Date(a.modified))
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: onMount"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      disableNextBtn = false
    }
  })

  /**
   * Function for navigate to the next page
   */
  const moveNext = async () => {
    try {
      // Check if a document template is selected for the session
      if (!session.document) throw "Kindly select a document template"
      showInstructModal = true
    } catch (error) {
      // Close any existing notification for document template
      notificationDocument.close()
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: Validating whether a document template is selected before generating the spreadsheet"
      notificationDocument = notify.danger(error, info)
    }
  }

  /**
   * Function for checking special characters
   * @param {String} value validating the value if any special characters found
   */
  const checkSpecialCharsWithoutKeyPress = (value) => {
    // Check if the session name contains any characters not allowed by the allowedCharsRegex
    if (!allowedCharsRegex.test(value)) {
      // Close any existing notification for special characters
      notificationSplChar.close()

      // Get the session name from value
      let sessionName = value

      // Replace any characters in the session name that are not letters, numbers, spaces, hyphens, parentheses, plus signs, ampersands, or periods
      let sanitizedText = sessionName.replace(/[^A-Z\d\s-()+&.:]/gi, "").trim()

      // Check if the sanitized text is different from the original pasted text
      if (sanitizedText !== sessionName) {
        // Display a danger notification indicating that only certain characters are allowed
        const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: Invalid character validation for the file name (part 2) during onBlur"
        notificationSplChar = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
      }

      // Update value with the sanitized text
      value = sanitizedText
    }
    return value
  }

  /**
   * Function for fetching the selected Document Template
   */
  const fetchDocumentTemp = async () => {
    try {
      // Disable the 'Next' button while fetching the document
      disableNextBtn = isTemplateFetching = true

      let documentData = await fetchSelectedDocumentTemp(session.document)

      // Extract the file template ID from the response
      fileTempID = documentData.file

      // Check if email and file are linked in the template
      session.toSendEmail = isEmailLinked = documentData.email ? true : false
      session.toGenerateFiles = isFileLinked = documentData.file ? true : false
      fileName = `${fileName}${session.toGenerateFiles ? "1" : "0"}`
      fileName = `${fileName}${session.toSendEmail ? "1" : "0"}-`
      // Parse the metadata fetched from the API
      parsedJson = JSON.parse(JSON.parse(JSON.stringify(documentData.metadata)))
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: While fetching selected document template details"
      notify.danger(error, info)
    } finally {
      // Re-enable the 'Next' button after fetching
      disableNextBtn = isTemplateFetching = false
    }
  }

  /**
   * Process file data to extract attributes from dynamic image layers.
   *
   * @param {string} fileData - JSON string containing layer information.
   * @returns {Array} An array of attributes extracted from dynamic image layers.
   */
  const processFileData = (fileData) => {
    // Parse the JSON string into an array of layers
    let layers = JSON.parse(fileData.layers)

    // Initialize an empty array to store layer attributes
    let layersAttributes = []

    // Iterate through the layers to extract attributes from dynamic image layers
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type == "image" && layers[i].dynamic) {
        if (layers[i].attribute != "qr" && layers[i].attribute != "url") {
          // Add the attribute to the layersAttributes array if it's not "qr" or "url"
          layersAttributes = [...layersAttributes, `${layers[i].attribute} (Filename with Filetype eg: .jpg, .jpeg, .png)`]
        }
      }
    }

    // Return the array of extracted attributes
    return layersAttributes
  }

  /**
   * @description - function to check not to exceed max characters
   * @param {String} value value to be validated
   * @param {"Session Name"|"Title"} name name of the value
   */
  const checkMaxCharacters = (value, type) => {
    // Check if the length of the session name exceeds the maximum allowed characters
    if (value.length > maxCharacters) {
      // Close any existing notification for maximum characters
      notificationMaxChar.close()

      // Truncate the session name to the maximum allowed characters
      value = value.slice(0, maxCharacters)

      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: Max count validation for the file name (part 2) during keypress / onBlur"
      // Display an information notification indicating the maximum allowed characters for the template name
      notificationMaxChar = notify.info(`${type} should not be more than ${maxCharacters} characters`, info)
    }
    return value
  }

  /**
   * function to check for given pattern to session name
   * @param e - to capture key event
   */
  const checkSpecialCharsName = (e) => {
    // Check if it's a keypress event and the pressed key is not allowed
    if (!allowedCharsRegex.test(e.key)) {
      // Prevent the default keypress behavior if the pressed key is not allowed
      e.preventDefault()
      // session.name += e.key
      fileName2 += e.key
      notificationSplChar.close()
      // Show a danger notification indicating the allowed characters
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: Invalid character validation for the file name (part 2) during keypress"
      notificationSplChar = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
      setTimeout(() => {
        // session.name = session.name.slice(0, -1)
        fileName2 = fileName2.slice(0, -1)
      }, 100)
    }
  }

  /**
   * Function to generate an Excel file based on the flatObject data
   */
  const initiateFileGeneration = async () => {
    try {
      // Create an empty object to hold the request body
      // let requestBody = {}

      // // Assign session properties to the request body
      // requestBody.name = session.name
      // requestBody.documentTemplate = session.document
      // requestBody.generateFile = session.toGenerateFiles
      // requestBody.sendEmail = session.toSendEmail

      // Create a new bulk data session using the 'createNewBulkSession' function
      // let bulkData = await createNewBulkSession(requestBody)

      // Check if the 'exceljs' library is not already loaded, then load it asynchronously
      await loadJs("ExcelJS", "assets/lib/exceljs.min.js")

      // console.log("passed loading")

      let layersAttributes = []

      // If the session is configured for file generation, fetch the file template using 'fetchFileTemplate'
      if (session.toGenerateFiles) {
        if (!fileTempID) throw "We couldn't find the file template associated with the document template."

        let dataFromFile = await fetchFileTemplate(fileTempID)

        layersAttributes = processFileData(dataFromFile)
      }

      // Set title and expiry information in the parsed JSON data
      // parsedJson.title = session.title

      parsedJson.expireOn = ""

      if (session.expiry) parsedJson.expireOn = formatDateToYearLast(session.expiry)

      // Flatten the parsed JSON data to a flat object
      let flatObject = flatenObject(parsedJson)

      // Get keys from the flatObject
      let keys = Object.keys(flatObject)

      // Separate nested keys and normal keys from the list of keys
      let nestedKeys = keys.filter((key) => key.includes("_") && !flatObject[key])

      let normalKeys = keys.filter((key) => !key.includes("_"))
      keys = [...nestedKeys, ...normalKeys]

      // If the session is configured for file generation, add 'layersAttributes' to the list of keys
      if (session.toGenerateFiles) {
        keys = [...keys, ...layersAttributes]
      }

      // Remove duplicate keys
      keys = [...new Set(keys)]

      // Create an array of values corresponding to the keys in the flatObject
      let values = []
      for (let i = 0; i < keys.length; i++) {
        flatObject[keys[i]] ? values.push(flatObject[keys[i]]) : values.push("")
      }

      // Modify the 'keys' array, renaming "expireOn" to "expiry"
      keys = keys.map((key) => (key === "expireOn" ? "expiry (Optional)" : key))

      // If not generating files, add "Filename" at the beginning of keys and an empty value in values
      if (!session.toGenerateFiles) {
        keys = ["Filename (with Filetype eg: .jpg, .jpeg, .png)", ...keys]
        values = ["", ...values]
      }

      // If sending emails, add "Email" to the keys and an empty value to the values
      if (session.toSendEmail) {
        keys = [...keys, "Email"]
        values = [...values, ""]
      }

      // Generate an Excel file using the 'generateXlFile' function
      await generateXlFile(keys, values, fileName + fileName2)

      // Redirect to the "/publish/bulk" route
      push("/publish/bulk")
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: During spreadsheet generation following the instructions"
      notify.danger(error, info)
    } finally {
      // Update the flag to hide the instruction modal
      showInstructModal = false
    }
  }

  const generateXlFile = async (keys, values, id) => {
    try {
      // console.log("issue hits")

      // Create a new Excel workbook
      const workbook = new ExcelJS.Workbook()

      // Add a worksheet named "My Sheet" to the workbook
      const worksheet = workbook.addWorksheet("My Sheet")

      // Always mention rowheight and colWidth, Omitting one property will throws error
      worksheet.properties = {
        defaultRowHeight: 15,
        defaultColWidth: 30,
      }

      // Configure the worksheet views with freezing the first row
      worksheet.views = [
        {
          state: "frozen",
          xSplit: 0,
          ySplit: 1, // Specify the row index to freeze (in this case, the first row)
          topLeftCell: "A2", // Specify the cell below the frozen row
          activeCell: "A2", // Specify the active cell after freezing
        },
      ]

      worksheet.addRow(capitalizeArrayEntries(keys))

      for (let i = 0; i < session.autoFillRows; i++) {
        worksheet.addRow(values)
      }

      // Write the workbook data to a buffer in xlsx format
      const buffer = await workbook.xlsx.writeBuffer()

      // Create a Blob from the buffer with the appropriate MIME type for Excel files
      let blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

      // Create a download link for the Blob and simulate a click to trigger the file download
      let link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = id + ".xlsx"
      link.click()
    } catch (error) {
      throw error
    }
  }

  /**
   * Function for fetching single document template based on the template chosen
   * @param {CustomEvent} e dispatched value from the component
   */
  const onDocTempChange = async (e) => {
    // Update the selected document template

    session.document = e.detail
    fileName = e.detail
    if (!e.detail) {
      session.document = null
    }
    // Check if a document template is selected (truthy value)
    if (session.document) {
      // If a document template is selected, fetch the selected document template asynchronously
      await fetchDocumentTemp()
    }
  }

  /**
   * Function for changing the session name based on the document template
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeSessionName = (e) => {
    try {
      // Check if the dispatched value from the component is "None"
      if (e.detail == "None") {
        isFileLinked = false
        isEmailLinked = false
        session.toGenerateFiles = isFileLinked
        session.toSendEmail = isEmailLinked
        // If the value is "None", set the session name to a default format: "New Session-current date"
        // session.name = `New Session-${new Date(Date.now()).toISOString().slice(0, 19).replace("T", " ")}`
        session.documentName = ""
        fileName2 = ""
      } else {
        fileName2 = e.detail
        session.documentName = e.detail
      }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: During filename (part2) autofill based on document template selection."
      notify.danger(error, info)
    }
  }

  /**
   * Formats a date to have the year at the end.
   * @param {string} inputDate - The input date in "yyyy-mm-dd" format.
   * @returns {string} The formatted date in "dd-mm-yyyy" format.
   */
  const formatDateToYearLast = (inputDate) => {
    const date = new Date(inputDate)

    // Extract day, month, and year components
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()

    // Format the date components into "dd-mm-yyyy" format
    const formattedDate = `${day}-${month}-${year}`
    return formattedDate
  }

  /**
   * Function for validating the toggle options based on the type (Email or File)
   * This function checks if a document template is selected and if Email and/or File templates are linked with it.
   * It displays appropriate danger notifications for different scenarios.
   * @param {string} type - The type of toggle being validated. Can be "Email" or "File".
   * @returns {boolean} - Returns true if the validation fails, otherwise false.
   */
  const validateToggle = (type) => {
    try {
      if (!session.document) throw "Kindly select a document template"
      if (isTemplateFetching) throw "Retrieving the document template. Please wait a moment before making your selection."
      if (!isEmailLinked && !isFileLinked) {
        session.toGenerateFiles = session.toSendEmail = false
        throw "Document Template doesn't have any linked File and Email templates"
      }
      if (type == "Email" && !isEmailLinked) {
        session.toSendEmail = false
        throw "Document Template doesn't have any linked Email template"
      }
      if (type == "File" && !isFileLinked) {
        session.toGenerateFiles = false
        throw "Document Template doesn't have any linked File template"
      }
    } catch (error) {
      console.error(error)
      notificationDocument.close()
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: During user selection, such as choosing whether to generate or upload a file, and whether to send an email -> validating the cases to enable / disable"
      notificationDocument = notify.danger(error, info)
    }
  }

  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoading = true

      // Store the document name from the event detail
      session.documentName = e.detail

      // Increment the page count to retrieve the next set of templates
      page++

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      if (page === 1) {
        startCount = page + 10
        if (maxPage === page) endCount = count
        else endCount = 10
      } else {
        startCount = startCount + 10
        if (maxPage === page) endCount = count
        else endCount = startCount + 9
      }

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: While fetching the list of document templates on Next button click"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoading = false
    }
  }

  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchPreviousTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoading = true

      // Store the document name from the event detail
      session.documentName = e.detail

      // Decrement the page count to retrieve the previous set of templates
      page--

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = startCount - 10
      endCount = startCount + 9

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: While fetching the list of document templates on Previous button click"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoading = false
    }
  }

  /**
   * Fetches the initial set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchInitialList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoading = true

      // Store the document name from the event detail
      session.documentName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = 1

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      count = documentList.count

      maxPage = Math.ceil(count / 10)

      // Calculate the updated start and end counts for template display
      startCount = 1

      endCount = count < 10 ? count : 10

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: While fetching the list of document templates on 'Move Forward' button click"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoading = false
    }
  }

  /**
   * Fetches the final set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFinalList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoading = true

      // Store the document name from the event detail
      session.documentName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = maxPage

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      count = documentList.count

      maxPage = Math.ceil(count / 10)

      // Calculate the updated start and end counts for template display
      startCount = (maxPage - 1) * 10 + 1
      endCount = count

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: While fetching the list of document templates on 'Move Last' button click"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoading = false
    }
  }

  const changeFileName = (e) => {
    try {
      if (!session.document) throw "Kindly select a document template"
      if (isTemplateFetching) throw "Retrieving the document template. Please wait a moment before making your selection."

      if (e.target.name == "generateFiles") session.toGenerateFiles = e.target.value == "true" ? true : false
      if (e.target.name == "sendEmail") session.toSendEmail = e.target.value == "true" ? true : false

      if (session.document) {
        fileName = session.document
        fileName = `${fileName}${session.toGenerateFiles ? "1" : "0"}`
        fileName = `${fileName}${session.toSendEmail ? "1" : "0"}-`
      }
      if (!session.document) fileName = ""
    } catch (error) {
      // Close any existing notification for document template
      notificationDocument.close()
      const info = "PAGE: Generate Spreadsheet (Bulk Upload)\nEVENT: During user selection, such as choosing whether to generate or upload a file, and whether to send an email (Changing filename based on the response)"
      notificationDocument = notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Bulk Upload</title>
</svelte:head>

{#if showInstructModal}
  <div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 z-50 overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
      <div class="flex justify-center p-6 text-center">
        <InstructModal
          on:click={() => {
            showInstructModal = false
          }}
          on:download={initiateFileGeneration}
        />
      </div>
    </div>
  </div>
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col justify-between rounded-md bg-white dark:bg-mdGray">
      <div class="w-full select-none p-6 mobile:p-12 xls:text-justify">
        <div class="w-full text-3xl font-bold dark:text-white mobile:text-5xl">Generate Spreadsheet</div>
        <div class="mt-6 w-full lg:w-1/2">
          <div class="break-words text-justify text-sm text-gray-500 mobile:text-base">Please provide a name for your new bulk document publishing session and kindly select a document template from which metadata will be imported.</div>
        </div>

        <div class="mt-6 flex w-full flex-col gap-3">
          <div class="flex w-full flex-col items-center mobile:flex-row">
            <div class="w-full select-none text-base font-medium text-gray-500 after:ml-0.5 after:text-red-500 after:content-['*']">Select the document template</div>
            <div class="mt-3 w-full mobile:mt-0">
              <DocDropdown on:moveLast={fetchFinalList} on:moveFirst={fetchInitialList} {showLoading} selectedName={session.documentName || "None"} on:itemSelect={onDocTempChange} on:selectedName={changeSessionName} on:fetchNext={fetchNextTemplates} on:fetchPrevious={fetchPreviousTemplates} {startCount} {endCount} {maxPage} {page} {count} selected={session.document || "Choose a Document template"} dropdownItems={$TemplatesList.document} />
            </div>
          </div>
          <div class="flex w-full flex-col items-center mobile:flex-row">
            <div class="w-full text-base font-medium text-gray-500">
              Do you want <strong>Generate</strong>
              or
              <strong>Upload</strong>
              Files ?
            </div>
            <div class="mt-3 flex h-[37.6px] w-full gap-3 mobile:mt-0">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="flex items-center gap-3"
                on:click={() => {
                  validateToggle("File")
                }}
              >
                <input on:change={changeFileName} bind:group={session.toGenerateFiles} id="generate" class="h-5 w-5 cursor-pointer disabled:cursor-not-allowed" type="radio" name="generateFiles" value={true} />
                <label for="generate" class="cursor-pointer text-base font-semibold {!isFileLinked && session.document ? 'cursor-not-allowed text-gray-200/50' : 'text-gray-800 dark:text-white'}">Generate</label>
              </div>
              <div class="flex items-center gap-3">
                <input on:change={changeFileName} bind:group={session.toGenerateFiles} type="radio" id="upload" class="h-5 w-5 cursor-pointer" name="generateFiles" value={false} />
                <label for="upload" class="cursor-pointer text-base font-semibold text-gray-800 dark:text-white">Upload</label>
              </div>
            </div>
          </div>
          <div class="flex w-full select-none flex-col items-center mobile:flex-row">
            <div class="w-full text-base font-medium text-gray-500">
              Do you want to <strong>Send Email</strong>
              after publishing ?
            </div>
            <div class="mt-3 flex h-[37.6px] w-full gap-3 mobile:mt-0">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="flex items-center gap-3"
                on:click={() => {
                  validateToggle("Email")
                }}
              >
                <input on:change={changeFileName} id="sendEmail" bind:group={session.toSendEmail} type="radio" class="h-5 w-5 cursor-pointer disabled:cursor-not-allowed" name="sendEmail" value={true} />
                <label for="sendEmail" class="cursor-pointer text-base font-semibold {!isEmailLinked && session.document ? 'cursor-not-allowed text-gray-200/50' : 'text-gray-800 dark:text-white'} ">Yes</label>
              </div>
              <div class="flex cursor-pointer items-center gap-3">
                <input on:change={changeFileName} id="dontSendEmail" class="h-5 w-5 cursor-pointer" bind:group={session.toSendEmail} type="radio" name="sendEmail" value={false} />
                <label for="dontSendEmail" class="cursor-pointer text-base font-semibold text-gray-800 dark:text-white">No</label>
              </div>
            </div>
          </div>

          <div class="w-full">
            <div class="w-full select-none text-base font-medium text-gray-500">
              Enter a file name for Spreadsheet <br />
              (You may edit it as you like)
            </div>
            <div class="flex w-full items-center gap-2 pt-3">
              <input readonly bind:value={fileName} required type="text" class="h-[37.6px] w-1/2 border-none bg-transparent text-end outline-none dark:text-white" placeholder="file name part-1" />
              <div class="relative h-[37.6px] w-1/2">
                <input
                  on:blur={(e) => {
                    fileName2 = checkMaxCharacters(fileName2, "Session Name")
                    fileName2 = checkSpecialCharsWithoutKeyPress(fileName2)
                  }}
                  on:keypress={() => {
                    fileName2 = checkMaxCharacters(fileName2, "Session Name")
                  }}
                  on:keypress={(e) => {
                    clearTimeout(timer)
                    timer = setTimeout(checkSpecialCharsName(e), 50)
                  }}
                  bind:value={fileName2}
                  type="text"
                  class="session-input absolute !h-full !w-full !pr-10 dark:text-white"
                  placeholder="Enter file name part-2"
                />
                <span class="absolute right-2 top-2.5 text-sm text-blue-500">.xlsx</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-full items-center justify-between px-6 pb-6 mobile:px-12">
        <button
          on:click={() => {
            push("/publish/bulk")
          }}
          type="button"
          class="flex h-9 w-9 min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-gray-900 focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-bodyblack md:w-32 lg:px-4"
        >
          <span>
            <i class="fa-solid fa-chevron-left" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Previous&nbsp;</span>
        </button>

        <button disabled={disableNextBtn} on:click={moveNext} type="button" class="disabled:text-white-200/50 flex h-9 w-9 min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-200/50 md:w-32 lg:px-4">
          <span class="select-none">&nbsp;Next&nbsp;&nbsp;</span>
          <span>
            <i class="fa-solid fa-chevron-right" />
          </span>
        </button>
      </div>
    </div>
  </div>

  <Footer />
</div>

<style lang="postcss">
  .session-input {
    @apply h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent pl-5 pr-3 text-left placeholder-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 invalid:focus:ring-red-500 mobile:mt-0  mobile:w-1/2 sm:text-sm;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
